import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {ProductBuyCart} from 'modules/product-card/components/ProductBuyCart';
import {ProductBuyReserveButton} from 'modules/product-card/components/ProductBuyReserveButton';
import {selectProductData} from 'modules/product-card/selectors';
import {FC} from 'react';

export const ProductBuy: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {canBuy, canReserve} = productData || {};

    if (canBuy) {
        return <ProductBuyCart />;
    }

    if (canReserve) {
        return <ProductBuyReserveButton />;
    }

    return null;
};
